import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import Div from "@jumbo/shared/Div";
import useApp from "../../hooks/useApp";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import cloneDeep from "lodash.clonedeep";
import { dispatch } from "app/store/store";
import VirtualizeAutocomplete from "app/Common/VirtualizeAutocomplete";
import {
  updateAccountFilters,
  updateAccountFiltersFormValues,
} from "app/store/slice/account-slice";

const AccountFiltersCustomizer = () => {
  // const theme = useJumboTheme();
  const { customizerVisibility, setCustomizerVisibility } = useApp();
  const { authUserData, globalCompaniesList } = useSelector(
    (state) => state.CommonReducer
  );

  const { accountFilterFormValues } = useSelector(
    (state) => state.AccountReducer
  );
  const [formValues, setFormValues] = useState({
    organizations: {
      source: globalCompaniesList, //globalFilterAccountsList
      value: accountFilterFormValues.organizations,
    },
  });

  const multiSelectChangeHandler = (name, value) => {
    let inputName = name;
    let inputValue = value != undefined && value != null ? value : "";
    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
      },
    }));
    dispatch(
      updateAccountFiltersFormValues({ type: inputName, data: inputValue })
    );
  };

  const applyFilter = async (isClose = true) => {
    let organizationArr = [];

    accountFilterFormValues.organizations.map((orgInfo) => {
      organizationArr.push(orgInfo.value);
    });
    //console.log("organizationArr", organizationArr);
    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      organizationArr =
        organizationArr.length > 0
          ? organizationArr
          : globalCompaniesList.map((orgInfo) => {
              return orgInfo.value;
            });
    }

    let selFilters = {
      organizations: organizationArr,
    };

    dispatch(updateAccountFilters(selFilters));

    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  const clearFilter = (isClose = true) => {
    let finalObj = cloneDeep(formValues);
    finalObj.organizations.value = [];

    setFormValues(finalObj);
    dispatch(updateAccountFiltersFormValues({ action: "delete" }));
    let organizationsArr = [];

    //If user is not system admin then we need to pass all the accounts/advertisers associated with that user.
    if (authUserData.is_sys_admin != "1") {
      organizationsArr =
        organizationsArr.length > 0
          ? organizationsArr
          : globalCompaniesList.map((orgInfo) => {
              return orgInfo.value;
            });
    }
    let selFilters = {
      organizations: organizationsArr,
    };

    dispatch(updateAccountFilters(selFilters));
    if (isClose != false) {
      setCustomizerVisibility(false);
    }
  };

  //To Apply Filters
  useEffect(() => {
    applyFilter();
  }, []);

  return (
    <Drawer
      anchor={"right"}
      open={customizerVisibility}
      onClose={() => setCustomizerVisibility(false)}
      sx={{
        zIndex: 1205,

        "& .MuiDrawer-paper": {
          width: 336,
        },
      }}
    >
      <Div
        sx={{
          display: "flex",
          minWidth: 0,
          position: "relative",
          zIndex: 2,
          p: (theme) => theme.spacing(1.5, 3),
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: 25,
        }}
      >
        <Typography variant={"h3"} mb={0} sx={{ fontSize: "14px" }}>
          Filters
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setCustomizerVisibility(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Div>
      <JumboScrollbar autoHide autoHideDuration={200} autoHideTimeout={500}>
        <Stack sx={{ px: 3, pt: 2 }}>
          {(authUserData.is_sys_admin == "1" ||
            globalCompaniesList.length > 1) && (
            <VirtualizeAutocomplete
              id="Organization"
              label="Organizations"
              placeholder="Search Organizations"
              list={globalCompaniesList}
              selectedValues={
                formValues.organizations.value != ""
                  ? formValues.organizations.value
                  : []
              }
              multiSelectChangeHandler={multiSelectChangeHandler}
              inputName="organizations"
            />
          )}
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ px: 3, pt: 2 }}
          spacing={2}
        >
          <Button variant="contained" onClick={applyFilter}>
            Apply
          </Button>
          <Button variant="contained" color="error" onClick={clearFilter}>
            Clear
          </Button>
        </Stack>
      </JumboScrollbar>
    </Drawer>
  );
};

export default AccountFiltersCustomizer;
